namespace GeniuzPOS.Purchase {
    export class PoCreditNoteAppDtColumns {
        static columnsKey = 'Purchase.PoCreditNoteAppDt';
    }
}
